import { RegularCheckBox } from '../../HouseStyle/Components/Checkboxes';

const CheckboxFilter = ({ setFilters, filter }) => {
    const setFilterValue = (checked, value) => {
        setFilters((filters) => {
            const newFilters = [...filters];
            let values = newFilters[filters.findIndex((e) => e.index == filter.index)].value;
            
            if(!checked) {
                const minSelection = filter.minSelection || 1;
                if (values.length <= minSelection) {
                  
                    return newFilters;
                }
                newFilters[filters.findIndex((e) => e.index == filter.index)].value = values.filter((a) => a != value);
            }
            if(checked) {
                values.push(Number(value));
                newFilters[filters.findIndex((e) => e.index == filter.index)].value = values;
            }
            return newFilters
        })
    }

    return <div className="d-flex w-100 h-100">
        <div className="bg-white rounded-4 h-100 p-4 border border-gray w-100">
            <h6 className="fw-bold">{filter.name}</h6>
            <div className="d-flex flex-row w-100 flex-wrap user-select-none">
                {filter.options.map((e, index) => {
                    // Create unique ID for each checkbox
                    const checkboxId = `${filter.index}-${e.value}`;
                    const isChecked = filter.value.find(b => b == e.value) != null;
                    
                    return (
                        <div key={index} className="me-3">
                            <RegularCheckBox
                                label={e.name}
                                value={isChecked}
                                setValue={(checked) => setFilterValue(checked, e.value)}
                            />
                        </div>
                    )
                })}
            </div>
        </div>
    </div>
}

export default CheckboxFilter;